import style from './productSection.scss';
import { isValidElement, ReactNode } from 'react';
import cn from 'classnames';

interface OwnProps {
  title?: ReactNode;
  classNames?: {
    wrapper?: string;
    container?: string;
  };
  children?: ReactNode;
  id?: string;
  hideTitle?: boolean;
}

export const ProductSection = ({ title, hideTitle, classNames, children, id }: OwnProps) => {
  const showTitle = !hideTitle && title !== undefined;

  return (
    <div id={id} className={cn(style.base, classNames?.wrapper)}>
      {showTitle && (
        <div className={style.title}>{isValidElement(title) ? title : <h3>{title}</h3>}</div>
      )}
      <div className={cn(classNames?.container)}>{children}</div>
    </div>
  );
};
